// historyAdapter.ts
export type UiHistory = {
  id: string
  user: {
    userId?: string
    mailAdress: string
  }
  batchId: string
  changeDate: Date | string
  reportType: string
  previusReportVersion: any
  changesThatWasMade: {
    added: any[]
    updated: any[]
    deleted: any[]
    csrdAdded: any[]
    csrdDeleted: any[]
    invoiceReportFieldsUpdated: any | null
    kickbackReportChange: any | null
  }
}

export function mapHistoryToUi(history: any): UiHistory {
  const rawChanges =
    history?.changesThatWasMade ??
    history?.changes ??
    history?.normalizedChanges ??
    {}

  const rawPrev =
    history?.previusReportVersion ??
    history?.previousReportVersion ??
    history?.normalizedPreviousReport ??
    {}

  const rawUser = history?.user ?? history?.User ?? {}

  return {
    id: String(history?.id ?? history?.Id ?? ''),
    user: {
      userId: rawUser?.userId ?? rawUser?.UserId ?? '',
      mailAdress:
        rawUser?.mailAdress ??
        rawUser?.MailAdress ??
        rawUser?.email ??
        ''
    },
    batchId: history?.batchId ?? history?.BatchId ?? '',
    changeDate: history?.changeDate ?? history?.ChangeDate ?? '',
    reportType: history?.reportType ?? history?.ReportType ?? '',
    previusReportVersion: {
      Invoices: rawPrev?.Invoices ?? rawPrev?.invoices ?? [],
      Report: rawPrev?.Report ?? rawPrev?.report ?? null,
      CsrdRows: rawPrev?.CsrdRows ?? rawPrev?.csrdRows ?? [],
      Kickback: rawPrev?.Kickback ?? rawPrev?.kickback ?? [],
      KickbackProject: rawPrev?.KickbackProject ?? rawPrev?.kickbackProject ?? []
    },
    changesThatWasMade: {
      added: rawChanges?.added ?? rawChanges?.Added ?? [],
      updated: rawChanges?.updated ?? rawChanges?.Updated ?? [],
      deleted: rawChanges?.deleted ?? rawChanges?.Deleted ?? [],
      csrdAdded: rawChanges?.csrdAdded ?? rawChanges?.CsrdAdded ?? [],
      csrdDeleted: rawChanges?.csrdDeleted ?? rawChanges?.CsrdDeleted ?? [],
      invoiceReportFieldsUpdated:
        rawChanges?.invoiceReportFieldsUpdated ??
        rawChanges?.InvoiceReportFieldsUpdated ??
        null,
      kickbackReportChange:
        rawChanges?.kickbackReportChange ??
        rawChanges?.KickbackReportChange ??
        null
    }
  }
}

export function mapHistoryListToUi(data: any[]): UiHistory[] {
  if (!Array.isArray(data)) return []
  return data.map(mapHistoryToUi)
}